export class LoanRequestModel {
	id: number;
	loan_uid: string;
	requested_at: string;
	loan_amount_requested: string;
	amount_approved: string;
	acceptance_status: string;
}
